import { useQuery } from "@tanstack/react-query";
import { getUserGeoDetails } from "api/user";
import { ApiResponse } from "constantVariables";
import { useUserAuth } from "context/authProvider";
import { useTenant } from "context/tenantProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "utils/axios";
import { decrypt } from "utils/crypto";
// import { showToast } from "utils/toast";
import { clearAllLocalStorage } from "utils/utility";

async function getUser() {
  return axiosInstance
    .get("users/get-profile", {
      params: {
        session: localStorage.getItem("session"),
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      return err.response.data;
    });
}

export function useGetUser() {
  return useQuery({
    queryKey: ["user-profile-details"],
    queryFn: getUser,
  });
}

export default function useUser() {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const { tenant, isLoading: tenantLoading } = useTenant();
  const navigate = useNavigate();
  const { setUser } = useUserAuth();
  const { data, isLoading, ...rest } = useGetUser();

  useEffect(() => {
    if (isLoading || !window || !data || tenantLoading) return;
    setLoading(false);

    if (data.statusCode !== ApiResponse.SUCCESS) {
      // if (data.message === "usageDurationPassed") {
      //   showToast(t("usageDurationPassed"), "error");
      // }
      navigate("/user-auth/login", {
        state: {
          usageDurationPassed: data.message === "usageDurationPassed",
        },
      });
      setUser(null);
      clearAllLocalStorage();
      return;
    }
    let decData = decrypt(data.data);
    const isKeyPendingSave = decData.keys?.find(
      (ele) => ele.type === "occasional" && ele.status === "pending"
    );
    if (isKeyPendingSave) {
      setUserData(decData);
      navigate("/activate-key");
    } else if (!decData?.form_response) {
      setUserData(decData);
      navigate(`/response-form/${decData._id}`);
    } else if (data.statusCode === 401) {
      navigate("/user-auth/login");
      setUser(null);
      clearAllLocalStorage();
    } else {
      setUserData(decData);
    }
  }, [tenant, isLoading, data, window, tenantLoading]);
  return {
    isLoading: loading || tenantLoading || isLoading,
    data: userData,
    ...rest,
  };
}

export const useGeoLocation = () => {
  return useQuery({
    queryKey: ["geoLocation"],
    queryFn: getUserGeoDetails,
  });
};
